import React, { useEffect, useState } from 'react';

interface NicknameModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (nickname: string) => void;
  googleName?: string;
}

const NicknameModal: React.FC<NicknameModalProps> = ({ isOpen, onClose, onConfirm, googleName }) => {
  const [nickname, setNickname] = useState(googleName || '');

  useEffect(() => {
    if (isOpen) {
      setNickname(googleName || '');
    }
  }, [isOpen, googleName]);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (nickname.trim()) {
      onConfirm(nickname);
      setNickname('');
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50">
      <div className="card-gaming max-w-md w-full mx-4">
        <h2 className="font-gaming text-gaming-purple text-lg tracking-wider mb-4">ELIGE TU NICKNAME</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block font-main text-white/70 text-sm mb-2">Nickname</label>
            <input
              type="text"
              value={nickname}
              onChange={(e) => setNickname(e.target.value)}
              className="w-full bg-white/5 border border-white/10 rounded px-3 py-2 text-white font-main focus:outline-none focus:border-gaming-purple"
              autoFocus
              required
            />
          </div>
          <button
            type="submit"
            className="btn-primary w-full py-3 font-gaming text-sm tracking-wider"
          >
            CONFIRMAR
          </button>
        </form>
      </div>
    </div>
  );
};

export default NicknameModal;
